import React from 'react'
import themes from '../../../theme'
import { useGlobalStore } from '../../../store'

const ArrowDownIos = () => {
  const { theme } = useGlobalStore()
  const color = themes[theme].components.MuiIconButton.styleOverrides.color

  return (
    <svg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13 1L7 7L1 1' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
    </svg>
  )
}

export default ArrowDownIos
